module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sidebar/sidebar.component.css
// module id = ./src/app/sidebar/sidebar.component.css
// module chunks = main